
export class ChannelEvents {
  static NEW_CHANNEL_SELECTED = 'new_channel_selected';
}
